export default "__VITE_ASSET__Dsm_Trog__"